export function CalendarAddIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M8 3a1 1 0 011 1v1h6V4a1 1 0 112 0v1h1a3 3 0 013 3v4.682A6 6 0 0112.682 21H6a3 3 0 01-3-3V8a3 3 0 013-3h1V4a1 1 0 011-1zm2.803 16A5.972 5.972 0 0110 16c0-1.537.578-2.938 1.528-4H5v6a1 1 0 001 1h4.803zM19 10V8a1 1 0 00-1-1h-1v1a1 1 0 11-2 0V7H9v1a1 1 0 01-2 0V7H6a1 1 0 00-1 1v2h14zm-2 3a1 1 0 10-2 0v2h-2a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2v-2z"
      ></path>
    </svg>
  );
}
